import { Controller } from 'react-hook-form'
import { cn } from '@/lib/utils'
import Combobox from '@/components/ui/combo-box'

const Selector = ({ field, value, errors, onChange, pages, disabled }) => {
    // Filter pages that have Instagram accounts and sort alphabetically
    const instagramPages = (pages || [])
        .filter((page, index, self) => index === self.findIndex((p) => p.id === page.id))
        .sort((a, b) => {
            const nameA = a?.name || ''
            const nameB = b?.name || ''
            return nameA.localeCompare(nameB)
        })

    const hasInstagramPages = instagramPages.length > 0

    const options = instagramPages.map((page) => ({
        value: page.id,
        page_id: page.id,
        label: page.id + ' - ' + page.name,
        searchLabel: page.id + ' - ' + page.name,
        displayLabel: page.id + ' - ' + page.name,
    }))

    const selectedOption = options.find((option) => option.value === value)
    const selectedLabel = selectedOption?.displayLabel

    return (
        <Combobox
            {...field}
            value={value}
            options={options}
            onChange={onChange}
            disabled={disabled || !hasInstagramPages}
            selectedLabel={selectedLabel}
            placeholder={hasInstagramPages ? 'Select Instagram account...' : 'No Instagram accounts connected'}
            className={cn(errors.instagramAccount && 'tw:!border-destructive')}
        />
    )
}
const InstagramPageSelector = ({ control, errors, value, onChange, pages, disabled }) => {
    return (
        <>
            <Controller
                name="instagramAccount"
                control={control}
                rules={{ required: false }}
                render={({ field }) => (
                    <Selector
                        field={field}
                        value={value}
                        errors={errors}
                        pages={pages}
                        onChange={onChange}
                        disabled={disabled}
                    />
                )}
            />
            {errors.instagramAccount && (
                <p className="tw:mt-1 tw:text-sm tw:text-error">{errors.instagramAccount.message}</p>
            )}
        </>
    )
}

export default InstagramPageSelector
